<template>
  <button
    :data-location="location"
    type="button"
    class="button-filter"
    :class="filterButtonClass"
    @click="filterExpanded = !filterExpanded"
  >
    <component :is="iconType"/>
  </button>
</template>

<script>
import LocationIcon from "@/components/svg/LocationIcon";
import IconPlus from "@/components/ui/IconPlus.vue";

export default {
  name: "BaseFilterButton",
  data: () => ({
    filterExpanded: false,
    IconPlus: IconPlus,
    IconLocation: LocationIcon,
  }),
  props: {
    location: {
      type: Boolean,
      required: false,
      default: false
    },
    collapseId: {
      type: String,
      required: true
    },
    state: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.filterExpanded = this.state;
      this.$watch('state', (value) => {
        this.filterExpanded = value;
      });
    })
  },
  computed: {
    iconType() {
      return this.location && !this.filterExpanded ? this.IconLocation : this.IconPlus;
    },
    filterButtonClass() {
      return this.filterExpanded ? 'expanded' : '';
    },
  },
  watch: {
    filterExpanded(value) {
      this.$emit('state', value);
    }
  },
}
</script>

<style scoped lang="scss">
@import "@/assets/sass/abstracts/_variables.scss";

.button-filter {
  width: 36px;
  height: 36px;
  z-index: 4;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  padding: 10px;
  background-color: $c_white;
  transition: all 0.2s ease;

  svg {
    fill: $c_medium_grey;
  }

  &:hover {
    @include media-breakpoint-up(md) {
      color: $c_white;
      background-color: $c_base;
    }
  }

  &:hover::v-deep {
    @include media-breakpoint-up(md) {
      svg {
        transition: all 0.2s ease;
        fill: $c_white;
      }
    }
  }

  &.expanded {
    background-color: #989898;

    svg {
      transform: rotate(45deg);
      fill: $c_white;
    }

    &:hover {
      color: $c_white;
      background-color: $c_base;

      svg {
        fill: $c_white;
      }
    }

    &:hover::v-deep {
      svg {
        fill: $c_white;
      }
    }

    svg {
      //width: 14px;
      //height: 14px;
    }
  }

  svg {
    width: 30px;
    height: auto;

    &.location-icon {
      //width: 12px;
      height: auto;
    }
  }
}
</style>
